// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_waves_ambient_shade/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_waves_ambient_shade: ModuleSchema = {
  "id": "core_waves_ambient_shade",
  "uniqueId": "B3D_JXF7E",
  "createdAt": "2026-10-08T14:25:13.063Z",
  "updatedAt": "2026-10-23T12:25:12.387Z",
  "label": "Ondine",
  "description": "Hollow tiered diffuser with a flat mounting shelf and configurable center bore.",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_2PTEO",
    "shade",
    "waves"
  ],
  "sliders": [
    {
      "key": "maxDiameter",
      "label": "Maximum Diameter",
      "min": 80,
      "max": 200,
      "step": 0.1,
      "default": 151.6,
      "unit": "mm"
    },
    {
      "key": "troughDiameter",
      "label": "Trough Diameter",
      "min": 70,
      "max": 190,
      "step": 0.1,
      "default": 127.6,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Shade Height",
      "min": 50,
      "max": 250,
      "step": 1,
      "default": 140,
      "unit": "mm"
    },
    {
      "key": "waveCount",
      "label": "Wave Tiers",
      "min": 1,
      "max": 10,
      "step": 1,
      "default": 2
    },
    {
      "key": "lowerTierHeight",
      "label": "Lower Tier Height (two tiers)",
      "min": 0,
      "max": 240,
      "step": 1,
      "default": 95,
      "unit": "mm"
    },
    {
      "key": "topDiameter",
      "label": "Top Diameter",
      "min": 60,
      "max": 220,
      "step": 0.1,
      "default": 105.8,
      "unit": "mm"
    },
    {
      "key": "waistDiameter",
      "label": "Waist Diameter",
      "min": 60,
      "max": 240,
      "step": 0.1,
      "default": 137.8,
      "unit": "mm"
    },
    {
      "key": "bottomDiameter",
      "label": "Bottom Diameter",
      "min": 60,
      "max": 260,
      "step": 0.1,
      "default": 151.6,
      "unit": "mm"
    },
    {
      "key": "wallThickness",
      "label": "Wall Thickness",
      "min": 0.8,
      "max": 5,
      "step": 0.1,
      "default": 1.55,
      "unit": "mm"
    },
    {
      "key": "mountingHoleDia",
      "label": "Mounting Hole Diameter",
      "min": 40,
      "max": 100,
      "step": 0.5,
      "default": 61,
      "unit": "mm"
    },
    {
      "key": "shelfThickness",
      "label": "Mounting Shelf Thickness",
      "min": 1,
      "max": 8,
      "step": 0.1,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "innerFilletRadius",
      "label": "Inner Wall-to-Shelf Fillet",
      "min": 0,
      "max": 16,
      "step": 0.5,
      "default": 3,
      "unit": "mm",
      "integerOnly": false
    },
    {
      "key": "lightVentCount",
      "label": "Semicircular Light Vents",
      "min": 0,
      "max": 24,
      "step": 1,
      "default": 8,
      "integerOnly": true
    },
    {
      "key": "lightVentDiameter",
      "label": "Light Vent Diameter",
      "min": 0,
      "max": 40,
      "step": 0.5,
      "default": 26,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "waves_ambient_shade",
      "label": "Ondine",
      "default": "#176a78",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [],
  "exportGroups": []
};
